const separateLastWord = (str) => {
  const arr = str.split(' ');
  const lastElem = arr[arr.length - 1];
  const strWithoutLast = arr.filter((elem, index) => index !== arr.length - 1).join(' ');
  return [strWithoutLast, lastElem];
};

export default separateLastWord;
